import type { ComponentProps } from "react";

import { cn } from "@/utils/cn";

import { type IconName, ICONS, type IconVariant } from "./registry";

export type { IconName, IconVariant };

interface IconProps extends Omit<ComponentProps<"svg">, "ref"> {
  /** Semantic icon name (see the registry). */
  name: IconName;
  /** Solid (`Bold`) or outline (`Linear`). Defaults to outline. */
  variant?: IconVariant;
  /** Square size in px. Defaults to 24. */
  size?: number;
}

/**
 * The app's single icon primitive. Renders a build-time Solar SVG that inherits
 * color from `currentColor`, so `text-*` token classes drive its color — never
 * hardcode a color here. Pick the glyph by meaning via `name`; the Bold/Linear
 * mapping lives in `./registry`.
 */
export default function Icon({ name, variant = "Linear", size = 24, className, ...props }: IconProps) {
  const Svg = ICONS[name][variant];

  return <Svg width={size} height={size} className={cn(className)} aria-hidden {...props} />;
}
